import { Button } from '@components/Button'
import { HeroIcon } from '@components/HeroIcon'
import { View, Text } from 'tamagui'

export function QuestionFooter() {
  return (
    <View
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <View
        p={'$spacing-inset-nano'}
        alignItems="center"
        gap="$spacing-inset-nano"
      >
        <HeroIcon
          icon={['fal', 'circle-check']}
          size={24}
          color="$neutral-200"
        />
        <Text
          fontFamily="$mulishRegular"
          fontSize="$font-size-xxxs"
          fontWeight={600}
          color="$neutral-200"
        >
          Concluir
        </Text>
      </View>
      <View>
        <Button disabled>
          <Text>Enviar respostas</Text>
        </Button>
      </View>
    </View>
  )
}
